import { defineComponent as _defineComponent } from 'vue'
import { onUnmounted, reactive, withDefaults } from 'vue';

interface Props {
  map: google.maps.Map;
  center: google.maps.LatLng;
  fillColor?: string;
  fillOpacity?: number;
  strokeColor?: string;
  strokeOpacity?: number;
  strokeWeight?: number;
  radius?: number;
  visible?: boolean;
  zIndex?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleMapsCircle',
  props: {
    map: null,
    center: null,
    fillColor: { default: '#FFFFFF' },
    fillOpacity: { default: 1 },
    strokeColor: { default: '#555555' },
    strokeOpacity: { default: 1 },
    strokeWeight: { default: 2 },
    radius: { default: 10 },
    visible: { type: Boolean, default: true },
    zIndex: { default: 10 }
  },
  setup(__props: any) {

const props = __props as { map: google.maps.Map, center: google.maps.LatLng, fillColor: string, fillOpacity: number, strokeColor: string, strokeOpacity: number, strokeWeight: number, radius: number, visible: boolean, zIndex: number }



const circle = reactive<google.maps.Circle>(
  new google.maps.Circle({
    map: props.map,
    center: props.center,
    fillColor: props.fillColor,
    fillOpacity: props.fillOpacity,
    strokeColor: props.strokeColor,
    strokeOpacity: props.strokeOpacity,
    strokeWeight: props.strokeWeight,
    radius: props.radius,
    visible: props.visible,
    zIndex: props.zIndex,
  }),
);

/* LIFECYCLE */

onUnmounted(() => {
  circle.setMap(null);
});

return { __sfc: true,props, circle }
}

})